import {TFunction} from "i18next";
import {Field} from "../../application/model/field/Field";
import {Y_AXIS_DEFAULT_CONFIG} from "./chartUtils";
import _ from "lodash";
import {TableDataChartBuilder} from "./TableDataChartBuilder";
import {services} from "../../application/service/services";


export class BarChartBuilder extends TableDataChartBuilder {

    constructor(viz: any,  t: TFunction, stacked: boolean) {
        super('bar', viz,  t, "dashboard.viz.distributionChart.group.other");
        this.stacked = stacked;
    }

    protected prepareChartObject(chartObject) {
        const chartOptions: any = chartObject.options;
        chartOptions.plugins.tooltip.mode = 'point';
        chartOptions.plugins.tooltip.callbacks = {
            title: function () {
            }
        };
        let orientation = this.viz.definition.spec.uiParams.orientation;
        orientation = (!_.isNil(orientation) && orientation.toLowerCase() === 'horizontal') ? 'horizontal' : 'vertical';
        this.parsingKey = orientation === 'horizontal' ? 'xAxisKey' : 'yAxisKey';
        chartOptions.indexAxis = orientation === 'horizontal' ? 'y' : 'x';

        chartOptions.scales = {};
        if (this.percentageMode) {

            chartOptions.scales.percentage = {
                ...Y_AXIS_DEFAULT_CONFIG, min: 0, max: 100, stacked: this.stacked,
                position: 'left',
                title: {
                    display: true
                },
                grid: {
                    drawOnChartArea: true,
                },
            };
        } else {
            chartOptions.scales.y = {...Y_AXIS_DEFAULT_CONFIG, stacked: this.stacked}
        }

        chartOptions.scales.x = {stacked: this.stacked, grid: {display: this.displayVerticalGrid}}

        if (chartOptions.plugins.legend && chartOptions.plugins.legend.display) {
            chartOptions.plugins.legend.onClick = this.legendOnClickHandler;
            chartOptions.plugins.legend.labels = {
                font: {
                    size: 14,
                    family: this.getFont()
                }
            };
        }

        if (this._displayLabelsInline) {
            chartOptions.plugins.datalabels = {
                ...chartOptions.plugins.datalabels,
                ...{
                    color: 'white',
                    formatter: value => this.percentageMode ? Math.round(value.percentage) + "﹪" : ""
                }
            }
        }
        return chartObject;
    }

    getDataToExport(): any[][] {
        const dataToExport = [];
        //Add Header
        const header = [];
        const datasetAndLabels = this.computeDatasetsAndLabels();

        const field = services.getFieldsService().getField(this.viz.definition.params.columns[0].field);
        header.push(field ? field.getLabel(this.t) : this.viz.definition.params.columns[0].field);
        header.push(this.t('dashboard.viz.pieChart.tooltip.count'));
        header.push(this.t('dashboard.viz.pieChart.tooltip.percentage'));
        dataToExport.push(header);

        //Add value
        datasetAndLabels.datasets
            .filter(value => !value.hidden)
            .forEach((value, index) => {
                const lineToExport = [];
                lineToExport.push(datasetAndLabels.labels[index]);
                lineToExport.push(value.data[value.data.length - 1].value);
                lineToExport.push(value.data[value.data.length - 1].percentage?.toFixed(2));
                dataToExport.push(lineToExport);
            })
        return dataToExport;
    }

}